<template>
  <div>
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="onTopClickLeft"
    >
      <a
        :href="
          routeValue === null ||
          routeValue === undefined ||
          routeValue.length === 0
            ? 'https://www.ptty.com.cn/wap/#/'
            : 'https://www.ptty.com.cn/wap/#/' + routeValue
        "
        slot="right"
        style="font-size:20px;"
      >
        <van-icon style="font-size:20px;" name="wap-home" />
      </a>
    </van-nav-bar>
    <div>
      <div class="horizontal-scroller">
        <!-- 横向滚动容器 -->
        <div class="scroll-container" ref="scrollContainer">
          <!-- 滚动内容区 -->
          <div
            @click="toUrl('0')"
            class="scroll-item"
            v-bind:style="{
              background: active === '0' ? '#fff' : '#EFEFEF'
            }"
          >
            项目报名
          </div>
          <div
            @click="toUrl('1')"
            class="scroll-item"
            v-bind:style="{
              background: active === '1' ? '#fff' : '#EFEFEF'
            }"
          >
            我的项目
          </div>
          <div
            @click="toUrl('2')"
            class="scroll-item"
            v-bind:style="{
              background: active === '2' ? '#fff' : '#EFEFEF'
            }"
          >
            赛事规程
          </div>
          <div
            @click="toUrl('3')"
            class="scroll-item"
            v-bind:style="{
              background: active === '3' ? '#fff' : '#EFEFEF'
            }"
          >
            名单公示
          </div>
          <div
            @click="toUrl('4')"
            class="scroll-item"
            v-bind:style="{
              background: active === '4' ? '#fff' : '#EFEFEF'
            }"
          >
            抽签公示
          </div>
          <div
            @click="toUrl('5')"
            class="scroll-item"
            v-bind:style="{
              background: active === '5' ? '#fff' : '#EFEFEF'
            }"
          >
            节目单
          </div>
          <div
            v-if="false"
            @click="toUrl('6')"
            class="scroll-item"
            v-bind:style="{
              background: active === '6' ? '#fff' : '#EFEFEF'
            }"
          >
            秩序册
          </div>
          <div
            @click="toUrl('7')"
            class="scroll-item"
            v-bind:style="{
              background: active === '7' ? '#fff' : '#EFEFEF'
            }"
          >
            比分直播
          </div>
          <div
            @click="toUrl('8')"
            class="scroll-item"
            v-bind:style="{
              background: active === '8' ? '#fff' : '#EFEFEF'
            }"
          >
            秩序册/成绩册/名次
          </div>
          <div
            v-if="false"
            @click="toUrl('9')"
            class="scroll-item"
            v-bind:style="{
              background: active === '9' ? '#fff' : '#EFEFEF'
            }"
          >
            排名
          </div>
          <div
            @click="toUrl('10')"
            class="scroll-item"
            v-bind:style="{
              background: active === '10' ? '#fff' : '#EFEFEF'
            }"
          >
            赛事指南
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: String,
      default: ""
    },
    ssid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      routeValue: "",
      title: ""
    };
  },
  mounted() {
    this.$nextTick(() => {
      var routeValue = localStorage.getItem("routeValue");
      this.routeValue = routeValue;

      this.lastScroll();
      this.setTitle();
    });
  },
  methods: {
    toUrl(mbIndex) {
      if (mbIndex === this.active) {
        return;
      }
      switch (mbIndex) {
        case "0": {
          this.$router.push({
            path: "/reportXm",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "1": {
          this.$router.push({
            path: "/alreadyBmxx",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "2": {
          this.title = "赛事规程";
          this.$router.push({
            path: "/ssgcIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "3": {
          this.title = "名单公示";
          this.$router.push({
            path: "/mdgsIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "4": {
          this.title = "抽签公示";
          this.$router.push({
            path: "/cqgsIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "5": {
          this.title = "节目单";
          this.$router.push({
            path: "/jmdIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
        case "6": {
          this.title = "秩序册";
          this.$router.push({
            path: "/changeXmIndex",
            query: {
              ssid: this.ssid,
              queryType: "zxc"
            }
          });
          break;
        }
        case "7": {
          this.title = "比分直播";
          this.$router.push({
            path: "/ssbfIndex",
            query: {
              ssid: this.ssid,
              queryType: "all"
            }
          });
          break;
        }
        case "8": {
          this.title = "成绩册";
          this.$router.push({
            path: "/changeXmIndex",
            query: {
              ssid: this.ssid,
              queryType: "cjc"
            }
          });
          break;
        }
        case "9": {
          this.title = "成绩排名";
          this.$router.push({
            path: "/changeXmIndex",
            query: {
              ssid: this.ssid,
              queryType: "cjpm"
            }
          });
          break;
        }
        case "10": {
          this.title = "赛事指南";
          this.$router.push({
            path: "/ssznIndex",
            query: {
              ssid: this.ssid
            }
          });
          break;
        }
      }
    },
    setTitle() {
      switch (this.active) {
        case "0": {
          this.title = "项目报名";
          break;
        }
        case "1": {
          this.title = "我的项目";
          break;
        }
        case "2": {
          this.title = "赛事规程";
          break;
        }
        case "3": {
          this.title = "名单公示";
          break;
        }
        case "4": {
          this.title = "抽签公示";
          break;
        }
        case "5": {
          this.title = "节目单";
          break;
        }
        case "6": {
          this.title = "秩序册";
          break;
        }
        case "7": {
          this.title = "比分直播";
          break;
        }
        case "8": {
          this.title = "秩序册/成绩册/名次";
          break;
        }
        case "9": {
          this.title = "成绩排名";
          break;
        }
        case "10": {
          this.title = "赛事指南";
          break;
        }
      }
    },
    lastScroll() {
      const container = this.$refs.scrollContainer;
      var screenWidth = window.innerWidth;
      var num = 0;
      if (parseInt(this.active) > 3 && parseInt(this.active) < 7) {
        num = screenWidth - 100;
      }
      if (parseInt(this.active) >= 7) {
        num = screenWidth * 2 - 100;
      }
      container.scrollTo({
        left: num
      });
    },
    hasPreviousPage() {
      // 方法1：history 长度
      if (window.history.length > 1) {
        return true;
      }
      // 方法2：检查是否有来源页面
      if (document.referrer && document.referrer !== "") {
        return true;
      }
      return false;
    },
    onTopClickLeft() {
      if (this.hasPreviousPage() && this.active === "7") {
        // 返回上一页
        this.$router.back();
      } else {
        this.$router.push({ path: "/xmIndex", query: { ssid: this.ssid } });
      }
      // return;
      // this.$router.push({ path: "/xmIndex", query: { ssid: this.ssid } });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.horizontal-scroller {
  width: 100%;
  overflow: hidden; /* 隐藏外部滚动条 */
  background: #fff;
  height: 65px;
}

.scroll-container {
  display: flex; /* Flex 横向布局 */
  overflow-x: auto; /* 启用横向滚动 */
  scrollbar-width: none; /* Firefox 隐藏滚动条 */
  -ms-overflow-style: none; /* IE 隐藏滚动条 */
  cursor: grab; /* 鼠标手势 */
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 5px;
  border-radius: 10px;
  background: #efefef;
}

.scroll-item {
  flex: 0 0 auto; /* 禁止伸缩 */
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  transition: transform 0.3s ease;
  padding: 7px;
  margin: 8px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/commonCom/TopItemCom.vue